<template>
  <div>
    <validation-observer ref="TopicFormValidator">
      <v-form>
        <v-card>
          <v-card-title>{{ $route.params.id ? 'トピック編集' : 'トピック追加' }}</v-card-title>
          <v-card-text>
            <!-- 表示開始日・表示終了日 -->
            <v-row>
              <v-col cols="12" md="4">
                <cs-date-picker
                  :date.sync="topic.start_date"
                  :minimum-date="systemDate"
                  @dateChangedCallback="topicStartDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: true, topicStartDateCheck: { end_date: topic.end_date } }"
                      name="表示開始日"
                      class="requiredMark"
                    >
                      <v-text-field
                        v-model="topic.start_date"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        clearable
                        hide-details="auto"
                        label="表示開始日"
                        persistent-hint
                        persistent-placeholder
                        readonly
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="4">
                <cs-date-picker
                  :date.sync="topic.end_date"
                  :minimum-date="systemDate"
                  @dateChangedCallback="topicEndDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="表示終了日"
                      class="requiredMark"
                    >
                      <v-text-field
                        v-model="topic.end_date"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        clearable
                        hide-details="auto"
                        label="表示終了日"
                        persistent-hint
                        persistent-placeholder
                        readonly
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
            <!-- /表示開始日・表示終了日 -->            

            <!-- 内容 -->
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:30"
                  name="内容"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="topic.content"
                    :error-messages="errors"
                    label="内容"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  >
                    <template v-slot:label>
                      <span>内容</span>
                      <span class="ml-1">
                        ({{ topic.content?.length || 0 }} / 30)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /内容 -->

            <!-- リンク -->
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="max:255|topicUrlCheck"
                  name="リンク"
                >
                  <v-text-field
                    v-model="topic.url"
                    :error-messages="errors"
                    label="リンク"                    
                    hide-details="auto"
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>リンク</span>
                      <span class="ml-1">
                        ({{ topic.url?.length || 0 }} / 255)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /リンク -->

          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import moment from 'moment'

export default {
  name: 'TopicForm',
  components: {
  },
  mixins: [],
  data () {
    return {
      systemDate: moment().format("YYYY-MM-DD"),
      topic: {
        id: null,
        start_date: null,
        end_date: null,
        content: null,
        url: null,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editAdminTopic({ id: this.$route.params.id }).then((content) => {
        this.topic = content
      })
    } else {
      this.newAdminTopic().then((content) => {
        this.topic = content
      })
    }
  },
  methods: {
    ...mapActions('AdminTopic', {
      newAdminTopic: 'new',
      editAdminTopic: 'edit',
      createAdminTopic: 'create',
      updateAdminTopic: 'update'
    }),
    registerButtonClickEvent () {
      let $self = this
      this.$refs.TopicFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      let params = {
        start_date: this.topic.start_date,
        end_date: this.topic.end_date,
        content: this.topic.content,
        url: this.topic.url?.trim() === '' ? null : this.topic.url,
      }

      if (this.$route.params.id) {
        this.updateAdminTopic({ id: this.$route.params.id, params: params }).then(() => {
          this.$router.push({ name: 'AdminTopics' })
        })
      } else {
        this.createAdminTopic({ params: params }).then(() => {
          this.$router.push({ name: 'AdminTopics', params: { resetPagination: true } })
        })
      }
    },
    /**
     * 表示開始日変更　コールバック
     */
    topicStartDateChangedCallback (value) {
      this.topic.start_date = value;
    },
    /**
     * 表示終了日変更　コールバック
     */
    topicEndDateChangedCallback (value) {
      this.topic.end_date = value;
    },
  }
}
</script>
